import {AutocompleteElement} from "react-hook-form-mui";
import {Chip} from "@mui/material";

/**
 * Renders a multi-select Autocomplete element with a11y features.
 */
const AutocompleteMultipleElement = (props) => {
  return (
    <AutocompleteElement
      id={props.id}
      name={props.name}
      label={props.label}
      textFieldProps={props.textFieldProps}
      control={props.control}
      fullWidth={props.fullWidth}
      multiple
      required={props.required}
      autocompleteProps={{
        // This is used to match values, so duplicates don't get added.
        isOptionEqualToValue: (option, newValue) => {
          return option === newValue;
        },
        // Added aria-label to the <Chip> for a11y compliance
        renderTags: (values, props) => {
          return (
            <>
              {values.map((value, i) => {
                const key = value.id ? value.id : value;
                const label = value.label ? value.label : value;
                return (
                  <Chip className=" MuiAutocomplete-tag MuiChip-sizeSmall"
                        key={key}
                        label={label}
                        aria-label={`Remove ${label}`}
                        onDelete={e => props({ index: i }).onDelete(e)}
                  />
                )
              })}
            </>
          );
        },
        ...props.autocompleteProps,
      }}
      onChange={props.onChange}
      options={props.options}
    />
  )
};
export default AutocompleteMultipleElement;
